Vue.component('ack-mobile-shop-filters', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-mobile-shop-filters',
	mounted() {
		let offcanvasEl = document.getElementById('mobile-shop-filters-offcanvas');
		this.offcanvas = new bootstrap.Offcanvas(offcanvasEl);
	},
	props: {
		filters: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters('localization', ['countryCode']),
		isUSorCA() {
			return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA';
		},
		conciergeLatam() {
			const latam = [
				'AR',
				'BO',
				'BR',
				'CL',
				'CO',
				'CR',
				'CU',
				'DO',
				'EC',
				'SV',
				'GT',
				'HN',
				'MX',
				'NI',
				'PA',
				'PY',
				'PE',
				'UY',
				'VE',
			];
			return latam.includes(this.countryCode.toUpperCase());
		},
		conciergeAustralia() {
			const australia = ['AU', 'NZ'];
			return australia.includes(this.countryCode.toUpperCase());
		},
	},
	data() {
		return {
			offcanvas: null,
			categories: [
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_42f22b61-0cef-4347-8c7e-dc4068919803.png?v=1699251755',
					alt: '3d_printers',
					description: '3D Printers',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Dual_Tanks.png?v=1707216660',
					alt: 'post_processing',
					description: 'Post Processing',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4-ALPHA_AI.png?v=1697951339',
					alt: 'software',
					description: 'Software',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Ackuretta_Concierge.png?v=1697951336',
					alt: 'services',
					description: 'Services',
					isUSorCA: true,
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Resins_e172f900-6bed-48ec-b7fa-3f0d0f9f8cb5.png?v=1699251755',
					alt: 'resins',
					description: 'Resins',
				},
				{
					image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_BPs.png?v=1703752449',
					alt: 'Accessories',
					description: 'Accessories',
				},
				{
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_Print_Screen_Pack_with_2.png?v=1725266561',
					alt: 'Spare Parts',
					description: 'Spare Parts',
				},
			],
			mobileMenuOpened: false,
			selectedCategory: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('shop', [
			'getProduct',
			'removeProduct',
			'removeCheckedFilter',
			'addCheckedFilter',
		]),
		showOffcanvasMenu() {
			this.mobileMenuOpened = !this.mobileMenuOpened;
		},

		showOffcanvas(alt_handle) {
			appLog.log(`on showOffcanvas with handle = ${alt_handle}`, LOG_TYPE.debug);
			this.selectedCategory = alt_handle;
			this.offcanvas.show();
		},
		hideOffcanvas() {
			appLog.log('on hideOffcanvas', LOG_TYPE.debug);
			this.selectedCategory = null;
			this.offcanvas.hide();
		},

		loadBundle(bundleTag) {
			this.$emit('load-bundle', bundleTag);
		},
	},
	beforeDestroy() {
		this.hideOffcanvas();
	},
	watch: {},
});
